import { Entities } from '../../store';
import { NotificationEntry } from './notifications.model';
import { NewsfeedApiResponseEntry, NewsfeedApiResponse } from './api.model';

export function transformNavigationNotifications(
  entries: NewsfeedApiResponseEntry[],
): Entities<NotificationEntry> {
  return entries.reduce((acc: Entities<NotificationEntry>, entry) => {
    const id =
      entry.type === 'contestAwardedToEmployer'
        ? entry.data.entry_id
        : entry.type === 'draftContest' ? entry.data.contestId : entry.data.id;
    return {
      ...acc,
      [`${entry.type}-${id}`]: transformNavigationNotification(entry),
    };
  }, {});
}

function stringToNumber(x?: number | string): number | undefined {
  return x ? Number(x) : undefined;
}

function transformNavigationNotification(
  entry: NewsfeedApiResponseEntry,
): NotificationEntry {
  // TODO: Standardise linkUrl. There's things like contestUrl for example.
  switch (entry.type) {
    case 'project':
      const exchangerate = Number(entry.data.exchangerate);
      const minBudget = stringToNumber(entry.data.minbudget);
      const maxBudget = stringToNumber(entry.data.maxbudget);
      return {
        type: entry.type,
        data: {
          address: entry.data.address,
          appendedDescr: entry.data.appended_descr,
          currency: entry.data.currency,
          currencyCode: entry.data.currencyCode,
          exchangerate: entry.data.exchangerate,
          featured: entry.data.featured,
          freeBidUntil: entry.data.free_bid_until,
          fulltime: entry.data.fulltime,
          hideBids: entry.data.hideBids,
          id: entry.data.id,
          imgUrl: entry.data.imgUrl,
          isLocal: entry.data.isLocal,
          isMinimallyPostedProject: entry.data.isMinimallyPostedProject,
          isTest: entry.data.isTest,
          jobs: entry.data.jobs,
          jobString: entry.data.jobString,
          linkUrl: entry.data.linkUrl,
          maxBudget,
          minBudget,
          minimallyPostedProjectBudgetSet:
            entry.data.minimallyPostedProjectBudgetSet,
          nonPublic: entry.data.nonpublic,
          projIsHourly: entry.data.projIsHourly,
          publicName: entry.data.publicName,
          showBudgetMinimallyPostedProject:
            entry.data.showBudgetMinimallyPostedProject,
          submitDate: entry.data.submitDate,
          text: entry.data.text,
          time: entry.data.time,
          title: entry.data.title,
          usdMaxbudget: maxBudget
            ? Math.round(maxBudget * exchangerate)
            : undefined,
          usdMinbudget: minBudget
            ? Math.round(minBudget * exchangerate)
            : undefined,
          userId: entry.data.userId,
          userName: entry.data.userName,
        },
      };
    case 'draftContest': {
      return {
        type: entry.type,
        data: {
          ...entry.data,
          linkUrl: entry.data.contestUrl,
        },
      };
    }
    default:
      return entry;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/navigation/notifications/notification.transformers.ts